import constants from '@/app-configs/constants'

export default [
  {
    path: '/users/list',
    name: 'users-list',
    component: () => import('@/views/user/users-list/UsersList.vue'),
    meta: {
      pageTitle: 'DEBTIA_USERS',
      breadcrumb: [
        {
          text: 'DEBTIA_USERS',
          active: true,
        },
      ],
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
    },
  },
  {
    path: '/users/view/:id',
    name: 'users-view',
    component: () => import('@/views/user/users-view/UsersView.vue'),
    meta: {
      action: constants.action.permissionUserView,
      resource: constants.resource.user,
    },
  },
  {
    path: '/users/edit/:id',
    name: 'user-edit',
    component: () => import('@/views/user/users-edit/UsersEdit.vue'),
    meta: {
      action: constants.action.permissionUserEdit,
      resource: constants.resource.user,
    },
  },
  {
    path: '/users/add',
    name: 'users-add',
    component: () => import('@/views/user/users-add/UsersAdd.vue'),
    meta: {
      title: 'add users',
      action: constants.action.permissionUserAdd,
      resource: constants.resource.user,
    },
  },
]
